import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import { type GetVacanciesTemplatesRequest } from '../types';

export const useGetVacanciesTemplates = (
  params: GetVacanciesTemplatesRequest
) => {
  return useQuery({
    queryKey: [QueryKey.GET_VACANCIES_TEMPLATES, params],
    queryFn: () => vacancyApi.getVacanciesTemplates(params),
  });
};
